<template>
	<div class="row">
		<div class="col-md-5">
			<div class="card">
				<div class="card-header bg-dark">
					<h3 class="mb-0 text-white">แก้ไขรายการผิดพลาด</h3>
				</div>
				<div class="card-body">
					<fix-tx-form />
				</div>
			</div>
		</div>
		<div class="col-md-12">
			<div class="row">
				<div class="col-md-3 col-6">
					<div class="card card-stats bg-dark">
						<div class="card-body">
							<h5 class="card-title text-white mb-0">ยอดเติมเครดิต</h5>
							<span class="h2 font-weight-bold text-white mb-0">
								{{ addCreditSum | format }}
							</span>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-6">
					<div class="card card-stats bg-default">
						<div class="card-body">
							<h5 class="card-title text-white mb-0">ยอดตัดเครดิต</h5>
							<span class="h2 font-weight-bold text-white mb-0">
								{{ subCreditSum | format }}
							</span>
						</div>
					</div>
				</div>
				<div class="col-md-3">
					<div class="card card-stats bg-dark">
						<div class="card-body">
							<h5 class="card-title text-white mb-0">ยอดธนาคารไม่รัน</h5>
							<span class="h2 font-weight-bold text-white mb-0">
								{{ bankSum | format }}
							</span>
						</div>
					</div>
				</div>
				<div class="col-md-3">
					<div class="card card-stats bg-default">
						<div class="card-body">
							<h5 class="card-title text-white mb-0">ยอดทรูมันนี่วอลเล็ตไม่รัน</h5>
							<span class="h2 font-weight-bold text-white mb-0">
								{{ truewalletSum | format }}
							</span>
						</div>
					</div>
				</div>
			</div>
			<fix-tx-list-panel :data="reports" @reload="reloadReport" />
		</div>
	</div>
</template>

<script>
import FixTxForm from '../backend-components/FixTx/FixTxForm'
import FixTxListPanel from '../backend-components/FixTx/FixTxListPanel'

import moment from 'moment'
import api from '../services'

export default {
	components: {
		FixTxForm,
		FixTxListPanel,
	},
	data() {
		return {
			reports: [],
		}
	},
	computed: {
		addCreditSum() {
			return this.reports.filter((x) => x.type === 'add').reduce((c, x) => c + x.amount, 0)
		},
		subCreditSum() {
			return this.reports.filter((x) => x.type === 'deduct').reduce((c, x) => c + x.amount, 0)
		},
		truewalletSum() {
			return this.reports
				.filter((x) => x.type === 'deposit' && x.transferFrom === 'TRUEWALLET')
				.reduce((c, x) => c + x.amount, 0)
		},
		bankSum() {
			return this.reports
				.filter((x) => x.type === 'deposit' && x.transferFrom !== 'TRUEWALLET')
				.reduce((c, x) => c + x.amount, 0)
		},
	},
	methods: {
		reloadReport(params) {
			api.get('/fix-tx', { params }).then((res) => {
				this.reports = res
			})
		},
	},
}
</script>
